module.exports = __webpack_public_path__ + "static/media/chetas_borse.e10a7b48.jpg";